var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"n2-valid",class:{'n2-validation-summary':_vm.hasError}},[_c('li',[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []

export { render, staticRenderFns }